import React from 'react';

export default function Hero() {
  return (
    <div 
      id="home" 
      className="pt-16"
      role="banner"
      aria-labelledby="hero-heading"
    >
      <div className="relative h-[600px]">
        <div className="absolute inset-0">
          <img       
            src="/steth.jpg"
            alt="Medical facility"
            className="w-full h-full object-cover"
            role="img"
          />
          <div 
            className="absolute inset-0 bg-primary-900/60"
            aria-hidden="true"
          />
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 
            id="hero-heading"
            className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            Your Health Is Our Priority.          
          </h1>
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Accepting New Patients
          </h2>
          <p className="mt-12 text-xl text-white max-w-3xl">
            Providing comprehensive primary care services focusing on preventive medicine, Obesity Medicine, and long-term wellness for you and your family.
          </p>
        </div>
      </div>
    </div>
  );
}